var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_19695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.375 14C25.375 10.9832 24.1766 8.08989 22.0433 5.95666C19.9101 3.82343 17.0168 2.625 14 2.625C10.9832 2.625 8.08989 3.82343 5.95666 5.95666C3.82343 8.08989 2.625 10.9832 2.625 14C2.625 17.0168 3.82343 19.9101 5.95666 22.0433C8.08989 24.1766 10.9832 25.375 14 25.375C17.0168 25.375 19.9101 24.1766 22.0433 22.0433C24.1766 19.9101 25.375 17.0168 25.375 14ZM0 14C0 10.287 1.475 6.72601 4.10051 4.10051C6.72601 1.475 10.287 0 14 0C17.713 0 21.274 1.475 23.8995 4.10051C26.525 6.72601 28 10.287 28 14C28 17.713 26.525 21.274 23.8995 23.8995C21.274 26.525 17.713 28 14 28C10.287 28 6.72601 26.525 4.10051 23.8995C1.475 21.274 0 17.713 0 14ZM19.5891 9.99141L14.9953 20.7102C14.8039 21.1531 14.3719 21.4375 13.8906 21.4375C13.8141 21.4375 13.732 21.432 13.65 21.4156C13.0922 21.3008 12.6875 20.8031 12.6875 20.2344V15.3125H7.76562C7.19688 15.3125 6.69922 14.9078 6.58984 14.35C6.475 13.7922 6.77031 13.2289 7.29531 13.0047L18.0141 8.41094C18.4789 8.21953 18.9984 8.31797 19.3375 8.66797C19.6875 9.0125 19.7859 9.5375 19.5945 9.99141H19.5891Z",
    fill: "#5F6F7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_19695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPage);
export default __webpack_public_path__ + "static/media/LandingPage.9eecf0405f4c8345254b72243be2796e.svg";
export { ForwardRef as ReactComponent };